const factor = 12
const length = 18 - 8
const tanh = (x: number) => (Math.tanh(Math.pow(Math.abs(x), 0.8) * factor - factor / 2) + 1) / 2
const linear = (x: number, min: number, max: number) => Math.max(0, x - min) / (max - min)

const waveformArray = new Float32Array(32)
const voiceCheckArray = new Uint8Array(64)
const prevCheckArray = new Uint8Array(64)

export function processWaveform(analyser: AnalyserNode) {
  analyser.getFloatFrequencyData(waveformArray)

  const val = Array.from(waveformArray)
    .slice(8, 18)
    .map((x, i) => x * (1 - Math.pow(i * (length - i - 1), 0.4) / length / length))

  const res = val.map((i) => tanh(linear(i, -90, Math.max(...val) + 8)))

  return res
}

export const awaitMediaStreamReady = async (analyser: AnalyserNode) => {
  analyser.fftSize = 128
  analyser.minDecibels = -96
  analyser.maxDecibels = 0
  analyser.smoothingTimeConstant = 0
  await new Promise<void>((resolve) => {
    const intv = setInterval(() => {
      analyser.getByteTimeDomainData(voiceCheckArray)
      if (voiceCheckArray.some((i) => i !== 0 && i !== 128)) {
        clearInterval(intv)
        resolve()
      }
    }, 50)
  })
  analyser.getByteTimeDomainData(prevCheckArray)
  await new Promise<void>((resolve) => {
    const intv = setInterval(() => {
      analyser.getByteTimeDomainData(voiceCheckArray)
      if (voiceCheckArray.some((i, idx) => prevCheckArray[idx] !== i)) {
        clearInterval(intv)
        resolve()
      }
    }, 50)
  })
}
